var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoHorizontalNegWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 102.667,
    height: 28,
    viewBox: "0 0 102.667 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:none}.cls-2{clip-path:url(#clip-path)}.cls-3{fill:#fff}\n        "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h102.667v28H0z",
    className: "cls-1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SkillYoga-horizontal-neg-white-sRGB",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1977",
    "data-name": "Group 1977"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_64",
    "data-name": "Group 64"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    d: "M7.54 0h3.32v12.865l4.312-4.516h4.107l-5.407 5.423 6.328 6.671h-4.258l-5.133-5.509v5.594H7.54z",
    className: "cls-3",
    "data-name": "Path 1",
    transform: "translate(5.362)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M17.569 5.017a1.968 1.968 0 0 1-1.335-.547 1.95 1.95 0 0 1-.564-1.37 1.882 1.882 0 0 1 .565-1.351 2.105 2.105 0 0 1 2.84 0A1.813 1.813 0 0 1 19.64 3.1a1.813 1.813 0 0 1-.565 1.369 1.9 1.9 0 0 1-1.506.548zM15.858 7.5h3.32v12.18h-3.251z",
    className: "cls-3",
    "data-name": "Path 2",
    transform: "translate(11.143 .851)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    d: "M19.61 0h3.32v20.529h-3.32z",
    className: "cls-3",
    "data-name": "Path 3",
    transform: "translate(13.945)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    d: "M23.3 0h3.32v20.529H23.3z",
    className: "cls-3",
    "data-name": "Path 4",
    transform: "translate(16.569)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    d: "M3.285 13.928a2.087 2.087 0 0 0 .548.616 2.687 2.687 0 0 0 .787.342 3.423 3.423 0 0 0 1.711 0A2.4 2.4 0 0 0 7 14.647a1.711 1.711 0 0 0 .513-.462 1.06 1.06 0 0 0 .205-.7c0-.5-.325-.855-.958-1.095a18.825 18.825 0 0 0-2.686-.719c-.479-.1-.941-.24-1.386-.376a5 5 0 0 1-1.181-.565 2.772 2.772 0 0 1-.838-.89 2.446 2.446 0 0 1-.395-1.283 3.421 3.421 0 0 1 .445-1.83A3.251 3.251 0 0 1 1.882 5.58a5.134 5.134 0 0 1 1.711-.6 11.279 11.279 0 0 1 1.865-.17A9.67 9.67 0 0 1 7.306 5a4.535 4.535 0 0 1 1.594.614 3.422 3.422 0 0 1 1.164 1.129 3.763 3.763 0 0 1 .5 1.813H7.495a1.471 1.471 0 0 0-.65-1.266 3.269 3.269 0 0 0-1.506-.325h-.582a1.711 1.711 0 0 0-.582.154 1.2 1.2 0 0 0-.445.325.855.855 0 0 0-.308.616.958.958 0 0 0 .325.7 2.515 2.515 0 0 0 .821.428 7.513 7.513 0 0 0 1.181.312l1.335.291c.462.12.924.24 1.369.393a4.62 4.62 0 0 1 1.2.6 2.891 2.891 0 0 1 .838.924 2.771 2.771 0 0 1 .308 1.369 3.507 3.507 0 0 1-1.711 3.2 4.963 4.963 0 0 1-1.711.667 9.482 9.482 0 0 1-1.865.171 9.653 9.653 0 0 1-1.987-.215 5.271 5.271 0 0 1-1.711-.667 4.192 4.192 0 0 1-1.249-1.261A3.934 3.934 0 0 1 0 13.039h3.063a1.813 1.813 0 0 0 .222.89z",
    className: "cls-3",
    "data-name": "Path 9",
    transform: "translate(0 3.419)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_5-2",
    d: "M33.388 16.171L27.81 4.88h1.711l4.723 9.72 4.414-9.72h1.454L31.147 23.6h-1.455z",
    className: "cls-3",
    "data-name": "Path 5-2",
    transform: "translate(19.776 3.468)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6-2",
    d: "M41.694 17.549a6.058 6.058 0 0 1-5.407-3.079 6.842 6.842 0 0 1 0-6.552 6.416 6.416 0 0 1 2.224-2.361 5.921 5.921 0 0 1 3.251-.907 6.127 6.127 0 0 1 3.148.8 6.057 6.057 0 0 1 2.277 2.28 6.944 6.944 0 0 1 0 6.552 6.313 6.313 0 0 1-2.242 2.361 5.921 5.921 0 0 1-3.251.907zm0-1.283a4.758 4.758 0 0 0 2.413-.633 4.517 4.517 0 0 0 1.711-1.813 5.661 5.661 0 0 0 .65-2.737 5.764 5.764 0 0 0-.582-2.6 4.6 4.6 0 0 0-4.192-2.549 4.689 4.689 0 0 0-2.4.633 4.568 4.568 0 0 0-1.706 1.813 5.422 5.422 0 0 0-.633 2.737A5.559 5.559 0 0 0 37.5 13.8a4.552 4.552 0 0 0 4.192 2.463z",
    className: "cls-3",
    "data-name": "Path 6-2",
    transform: "translate(25.21 3.305)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7-2",
    d: "M49.784 24.712a9.669 9.669 0 0 1-2.43-.325 6.845 6.845 0 0 1-2.07-.855l.222-1.283a6.674 6.674 0 0 0 2 .855 8.557 8.557 0 0 0 2.276.325 5.014 5.014 0 0 0 3.884-1.369 6.466 6.466 0 0 0 1.215-4.379v-2.806a4.637 4.637 0 0 1-1.981 1.984 5.9 5.9 0 0 1-2.943.719 5.8 5.8 0 0 1-5.221-3.078 6.739 6.739 0 0 1-.8-3.421 6.688 6.688 0 0 1 .77-3.2 6.228 6.228 0 0 1 2.207-2.361 5.939 5.939 0 0 1 5.987-.189 5.013 5.013 0 0 1 1.968 1.95V5h1.386v12.475a7.817 7.817 0 0 1-1.608 5.406 6.332 6.332 0 0 1-4.862 1.831zm.411-8.417a4.655 4.655 0 0 0 2.413-.633 4.756 4.756 0 0 0 1.711-1.83 5.713 5.713 0 0 0 .633-2.7 5.542 5.542 0 0 0-.633-2.6 4.706 4.706 0 0 0-8.333-.12 5.422 5.422 0 0 0-.633 2.737A5.559 5.559 0 0 0 46 13.831a4.552 4.552 0 0 0 4.192 2.549z",
    className: "cls-3",
    "data-name": "Path 7-2",
    transform: "translate(31.238 3.276)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8-2",
    d: "M58.759 17.55a5.8 5.8 0 0 1-5.133-3.079 6.739 6.739 0 0 1-.8-3.421 6.688 6.688 0 0 1 .77-3.2A6.228 6.228 0 0 1 55.8 5.49a5.939 5.939 0 0 1 5.886-.12 5.013 5.013 0 0 1 1.968 1.95V5.045h1.454v12.18h-1.387V14.95a5.133 5.133 0 0 1-2.036 1.9 6.076 6.076 0 0 1-2.926.7zM59 16.267a4.655 4.655 0 0 0 2.43-.633 4.6 4.6 0 0 0 1.711-1.813 5.525 5.525 0 0 0 .65-2.7 5.542 5.542 0 0 0-.6-2.617 4.706 4.706 0 0 0-8.35-.12 5.422 5.422 0 0 0-.633 2.737 5.559 5.559 0 0 0 .633 2.686 4.552 4.552 0 0 0 4.192 2.549z",
    className: "cls-3",
    "data-name": "Path 8-2",
    transform: "translate(37.559 3.303)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoHorizontalNegWhite);
export default __webpack_public_path__ + "static/media/logo-horizontal-neg-white.5c578525.svg";
export { ForwardRef as ReactComponent };